import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const StyledPlatforms = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  max-height: 33rem;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 1rem;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    width: 100%;
    margin-bottom: 0;
  }

  span {
    font-weight: normal;
    cursor: pointer;
    font-size: 1.2rem;
    color: ${props => props.theme.colors.red};
    text-decoration: underline;
  }
`;

export const StyledPlatformListing = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
